import Button from 'components/ui/button';

interface Props {
  /** Título do ciclo escolhido, encerrado. */
  ciclo: string;
  onVoltar: () => void;
}

/** RDV-26 a RDV-28: painel acima das seções quando o ciclo escolhido não é o aberto; as seções continuam (AD-038). */
export default function PainelDeCicloEncerrado({ ciclo, onVoltar }: Props) {
  return (
    <div className="mt-3.5 flex flex-col gap-3 rounded-jj-lg bg-brand-white px-8 py-[30px] shadow-jj-01">
      <span className="self-start rounded-jj-pill bg-surface-200 px-[13px] py-1.5 font-display text-[11px] font-bold text-content">
        Ciclo encerrado
      </span>
      <p className="m-0 font-display text-lg font-bold text-brand-blue-dark">{`Ciclo ${ciclo}`}</p>
      <p className="m-0 max-w-[560px] text-[13px] leading-[1.65] text-content">
        As realizações deste ciclo já foram apreciadas. As que receberam destaque estão reunidas em Meus destaques.
      </p>
      <div className="mt-1.5 flex flex-wrap gap-2.5">
        <Button variant="solido" onClick={onVoltar}>
          Voltar ao ciclo atual
        </Button>
        <Button variant="secundario" to="/destaques">
          Ver todos os reconhecimentos
        </Button>
      </div>
    </div>
  );
}
